import { useEffect } from 'react';
import { useCurrentUser } from 'customHooks/useCurrentUser';
import { DateTime } from 'luxon';

const useCapterra = () => {
    const currentUser = useCurrentUser();

    useEffect(() => {
        const { VITE_DASHBOARD_CAPTERRA_ID, VITE_DASHBOARD_CAPTERRA_KEY } = import.meta.env;
        currentUser.created_at = DateTime.now().minus({ day: 10 }).toISO();

        if (
            currentUser &&
            VITE_DASHBOARD_CAPTERRA_ID &&
            VITE_DASHBOARD_CAPTERRA_KEY &&
            currentUser.created_at &&
            DateTime.fromISO(currentUser.created_at) > DateTime.now().minus({ day: 30 })
        ) {
            const script = document.createElement('script');

            script.async = true;
            script.src = `https://ct.capterra.com/capterra_tracker.js?vid=${VITE_DASHBOARD_CAPTERRA_ID}&vkey=${VITE_DASHBOARD_CAPTERRA_KEY}`;

            document.body.appendChild(script);
        }
    }, [currentUser]);
};

export { useCapterra };
